import React from 'react';
import Modal from './Modal';

interface ConfirmModalProps {
  isActive: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message?: string;
  messages?: string[];
  confirmText?: string;
  cancelText?: string;
  isConfirmDanger?: boolean;
  confirmIcon?: string;
}

/**
 * A confirmation modal for actions like deletion
 */
const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isActive,
  onClose,
  onConfirm,
  title,
  message,
  messages,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isConfirmDanger = false,
  confirmIcon,
}) => {
  // If messages is provided, use it, otherwise create an array from message
  const messagesToDisplay = messages || (message ? [message] : []);

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const footer = (
    <div className="buttons">
      <button className="button" onClick={onClose}>
        {cancelText}
      </button>
      <button
        className={`button ${isConfirmDanger ? 'is-danger' : 'is-primary'}`}
        onClick={handleConfirm}
      >
        {confirmIcon && <span className="icon"><i className={confirmIcon}></i></span>}
        <span>{confirmText}</span>
      </button>
    </div>
  );

  return (
    <Modal
      isActive={isActive}
      onClose={onClose}
      title={title}
      footer={footer}
      closeOnBackgroundClick={false}
    >
      {messagesToDisplay.map((msg: string, index: number) => (
        <p key={index}>{msg}</p>
      ))}
    </Modal>
  );
};

export default ConfirmModal;
